export const environment = {
  production: true,

  // Local build-version manifest, stamped at build time by
  // scripts/generate-version.js (see package.json "prebuild"). Fetched
  // cache-busted on every startup to detect a newly deployed build.
  versionManifestUrl: 'assets/version.json',

  // Optional server-driven update policy. Leave empty to disable remote
  // version checks entirely (local build-version detection still runs).
  remoteVersionConfigUrl: '',
  firebaseConfig: {
  apiKey: "AIzaSyAjNZDNJiDWa7E3ADeMZewHksNLA4qz4-c",
  authDomain: "swasth-plus.firebaseapp.com",
  databaseURL: "https://swasth-plus-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "swasth-plus",
  storageBucket: "swasth-plus.appspot.com",
  messagingSenderId: "75257375636",
  appId: "1:75257375636:web:6b7fc8d17d8775111c3d81",
  measurementId: "G-7FZDSD55K6"
  }
};
